export default __webpack_public_path__ + "static/media/django.92d5c5b7.svg";